// HowToTrade.tsx

import * as React from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogOverlay,
  DialogPortal,
} from "./ui/dialog";
import { Lock } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../components/ui/carousel";
import { Button } from "../components/ui/button";
import welcomeIcon from "../assets/images/invest-welcome.png";
import withdrawAndDeposit from "../assets/images/depositMade.png";

const HowToInvest = ({ open, setOpen }) => {
  const carouselSteps = [
    {
      icon: welcomeIcon,
      title: "Welcome to Your Investment",
      description:
        "This is your central hub for managing all your finances. Connect, transact and grow with ease",
    },
    {
      icon: withdrawAndDeposit,
      title: "Deposit & Withdraw Funds",
      description: "Transfer money quickly and securely to anyone, anywhere.",
    },
  ];
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogPortal>
        <DialogOverlay className="bg-[#a14aff]/45 backdrop-blur-[4px] fixed inset-0" />

        {/* Trigger Button */}
        <DialogTrigger asChild></DialogTrigger>

        {/* Dialog Content */}
        <DialogContent
          className="max-w-[800px] rounded-lg p-4"
          aria-describedby="carousel-description"
        >
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold flex justify-center items-center">
              {"How to use your Digital Wallet"}
            </DialogTitle>
          </DialogHeader>

          {/* Carousel Content */}
          <div id="carousel-description" className="mt-4">
            <Carousel className="w-full max-w-[650px] mx-auto">
              <CarouselContent>
                {carouselSteps.map((step, index) => (
                  <CarouselItem key={index}>
                    <div className="p-2">
                      <div className="w-full max-w-5xl  p-12 flex flex-col items-center text-center">
                        {/* Success Image */}
                        <img
                          src={step.icon}
                          alt={step.icon}
                          width={150}
                          height={150}
                          className="mb-6"
                        />

                        {/* Step Title */}
                        <h2 className="text-2xl font-bold text-purple-700 mb-4">
                          {step.title}
                        </h2>
                        {/* Step Description */}
                        <p className="text-lg font-normal text-gray-600 mb-10">
                          {step.description}
                        </p>

                        {/* Done Button */}
                        <Button
                          onClick={() => {
                            setOpen(false);
                          }}
                          className="w-1/2 p-2 bg-gradient-to-tr from-purple-500 to-rose-500 text-white rounded-full font-bold"
                        >
                          Explore Investment
                        </Button>

                        {/* Bottom Lock Label */}
                        <div className="flex items-center justify-center gap-1 text-sm text-gray-500 mt-6">
                          <Lock size={12} />
                          <p>Secured by 80Eight</p>
                        </div>
                      </div>
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};

export default HowToInvest;
